// add a dismiss button to the instructions
document.getElementById('instructions').addEventListener('click', function() {
  document.getElementById('instructions').style.display = 'none';
});

// Mobile bottom sheets: two accordion panels (Trunk / Foliage) share one slot. The
// open section is a class on #control-col — 'sheet-trunk', 'sheet-foliage', or
// neither. Opening one closes the other, so only ~25% of the screen is ever covered.
const SHEET_CLASS = { trunk: 'sheet-trunk', foliage: 'sheet-foliage' };

// Open the given section (closing the other), or pass null/falsy to close both.
// Buttons that slide off-screen while a sheet is open (grow/add to the left,
// shape/prune/zen to the right). See the .sheet-hidden rules in tree.css.
const SHEET_HIDE_SELECTOR =
  '.grow-more-btn, .main-branches-btn, #shapeModeToggle, #pruneModeToggle, #zen-button';

function openSheet(section) {
  const col = document.getElementById('control-col');
  col.classList.toggle('sheet-trunk', section === 'trunk');
  col.classList.toggle('sheet-foliage', section === 'foliage');
  // Toggle the slide-out class directly on each floating button rather than keying the
  // CSS off an ancestor (#control-col) class — Safari reverses an element's own class
  // reliably, but re-evaluates ancestor (descendant / :has()) selectors flakily on close,
  // which left the buttons stuck off-screen.
  const hidden = section === 'trunk' || section === 'foliage';
  document
    .querySelectorAll(SHEET_HIDE_SELECTOR)
    .forEach((el) => el.classList.toggle('sheet-hidden', hidden));
}
// Open a specific section directly (no toggle) — used by the rage-tap shortcut.
window.openControlSheet = function (section) { openSheet(section || 'trunk'); };

// Drive each tab handle: a vertical swipe is directional (up opens that section,
// down closes), while a near-stationary press is a tap that toggles it. We resolve
// on pointerup rather than live-tracking the finger because open/closed is a CSS
// class (max-height transition), not a transform.
function initSheetGestures() {
  const col = document.getElementById('control-col');
  const tabs = document.querySelectorAll('.sheet-tab');
  if (!col || !tabs.length) return;

  const SWIPE_THRESHOLD = 28; // px of vertical travel before it counts as a swipe

  tabs.forEach((tab) => {
    const section = tab.dataset.sheet; // 'trunk' | 'foliage'
    let startY = 0;
    let dragging = false;

    tab.addEventListener('pointerdown', (e) => {
      dragging = true;
      startY = e.clientY;
      tab.setPointerCapture(e.pointerId);
    });

    tab.addEventListener('pointerup', (e) => {
      if (!dragging) return;
      dragging = false;
      const dy = e.clientY - startY;
      if (Math.abs(dy) >= SWIPE_THRESHOLD) {
        openSheet(dy < 0 ? section : null); // up → open this one, down → close
      } else {
        const isOpen = col.classList.contains(SHEET_CLASS[section]);
        openSheet(isOpen ? null : section); // tap → toggle this one
      }
    });

    tab.addEventListener('pointercancel', () => { dragging = false; });
  });
}

initSheetGestures();